import { FileExtension, wordFileExtensionSchema, WordFileExtension, emailFileExtensionSchema, excelFileExtensionSchema } from '../enums.mjs';

const EXTRACTABLE_EXTENSIONS = [FileExtension.pdf];
function isExtractableExtension(extension) {
    return EXTRACTABLE_EXTENSIONS.includes(extension);
}
const pdfConvertibleFileExtensionSchema = wordFileExtensionSchema.exclude([WordFileExtension.docm]);
function isPdfConvertibleExtension(extension) {
    return pdfConvertibleFileExtensionSchema.safeParse(extension).success;
}
const CONTRACT_EXTRACTABLE_EXTENSIONS = [
    ...EXTRACTABLE_EXTENSIONS,
    ...pdfConvertibleFileExtensionSchema.options,
];
function isContractExtractableExtension(extension) {
    return CONTRACT_EXTRACTABLE_EXTENSIONS.includes(extension);
}
function isExcelExtension(extension) {
    return excelFileExtensionSchema.safeParse(extension).success;
}
function isWipExtractableExtension(extension) {
    return isExtractableExtension(extension) || isExcelExtension(extension);
}
function isEmailExtension(extension) {
    return emailFileExtensionSchema.safeParse(extension).success;
}

export { CONTRACT_EXTRACTABLE_EXTENSIONS, EXTRACTABLE_EXTENSIONS, isContractExtractableExtension, isEmailExtension, isExcelExtension, isExtractableExtension, isPdfConvertibleExtension, isWipExtractableExtension };
